import request from "../common/request";
import store from "@/store";
import { IGetShareInfo, INewsList } from "./types";
/**
 * 网络请求类 接口调用
 */
class RequestIndex {
  get token() {
    return store.state.token;
  }
  get appId() {
    return store.state.appId;
  }

  /**
   * 获取新闻列表
   * @param isCarousel 是否轮播
   * @param columnId 栏目Id
   * @param lastId 翻页时最后一条数据Id
   * @param lastSortNo 翻页时最后一条数据的排序号
   * @param lastOnlineTime 翻页时最后一条数据的上线时间
   */
  getInfoList(
    columnId: number,
    lastId?: string,
    lastSortNo?: string,
    lastOnlineTime?: string
  ): Promise<INewsList> {
    return request.post("/info/news.html", {
      appId: this.appId,
      isCarousel: true,
      columnId,
      lastId,
      lastSortNo,
      lastOnlineTime
    });
  }
  /**
   * 获取唤醒app信息接口
   * @param appId appId
   */
  getShareInfo(appId: string): Promise<IGetShareInfo> {
    return request.post("https://exapi.cqliving.com/getShareInfo.html", {
      appId
    });
  }
}
export default new RequestIndex();
